import Axios from 'axios'
import { apiUrls, setAuthorizationHeaders, setHeaders } from '../utils'

const { newOOBaseUrl } = apiUrls

interface AppDownloadResponse<T = any> {
  data: T
  status: number
  statusText: string
  headers: any
  config: any
}

interface AppDownloadApis {
  sendSMSForAppDownload: (body: Record<string, any>) => Promise<AppDownloadResponse>
}

const appDownloadApis: AppDownloadApis = {

  sendSMSForAppDownload: async (body) => {
    const url = `${newOOBaseUrl}customer/send-sms-for-app-download`
    return await Axios({
      url,
      method: 'POST',
      headers: setHeaders(setAuthorizationHeaders()),
      data: body
    })
  }

}

export default appDownloadApis
